const itemTypes = [
    { label: 'Avatar', value: 'avatar' },
    { label: 'Voucher', value: 'consumable' },
    { label: 'Lottery', value: 'lottery_ticket' },
];

export default itemTypes;
